"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _Mfa = _interopRequireDefault(require("./Mfa"));
var _Classlink = _interopRequireDefault(require("./Classlink.svg"));
var _Clever = _interopRequireDefault(require("./Clever.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Appdefs = window.cccisd && window.cccisd.appDefs;
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var Fortress = window.cccisd && window.cccisd.fortress;
var LoginForm = function LoginForm(props) {
  var bottomInstructions = props.bottomInstructions,
    defaultRedirectUrl = props.defaultRedirectUrl,
    onSuccess = props.onSuccess,
    showPasswordByDefault = props.showPasswordByDefault,
    showPasswordToggle = props.showPasswordToggle,
    topInstructions = props.topInstructions;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    performRedirect = _useState2[0],
    setPerformRedirect = _useState2[1];
  var _useState3 = (0, _react.useState)(defaultRedirectUrl),
    _useState4 = _slicedToArray(_useState3, 2),
    redirectUrl = _useState4[0],
    setRedirectUrl = _useState4[1];
  var _useState5 = (0, _react.useState)(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    mfaProps = _useState6[0],
    setMfaProps = _useState6[1];
  var urlParams = (0, _react.useMemo)(function () {
    return {
      queryParams: window.location.search || '',
      anchor: window.location.hash || ''
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (performRedirect && redirectUrl) {
      if (redirectUrl === window.location.href) {
        window.location.reload();
      } else {
        window.location.href = redirectUrl;
      }
    }
  }, [performRedirect, redirectUrl, urlParams]);
  var validate = function validate(values) {
    var errors = {};
    if (!values.username) {
      errors.username = 'Username or email is required.';
    }
    if (!values.password) {
      errors.password = 'Password is required.';
    }
    return errors;
  };

  // title, buttonText, accountLabel, passwordLabel could come from Fortress config (legacy) or Appdefs (current)
  var title = '';
  if ('title' in props) {
    title = props.title;
  } else if ((0, _get2["default"])(Appdefs, 'app.login.labels.title', '')) {
    title = (0, _get2["default"])(Appdefs, 'app.login.labels.title', '');
  } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText', null)) {
    title = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText');
  }
  var buttonText = 'Log In';
  if (props.buttonText) {
    buttonText = props.buttonText;
  } else if ((0, _get2["default"])(Appdefs, 'app.login.labels.buttonText', null)) {
    buttonText = (0, _get2["default"])(Appdefs, 'app.login.labels.buttonText');
  } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText', null)) {
    buttonText = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.loginActionText');
  }
  var accountLabel = 'Email / Username:';
  if ((0, _get2["default"])(Appdefs, 'app.login.labels.username', null)) {
    accountLabel = (0, _get2["default"])(Appdefs, 'app.login.labels.username');
  } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.account', null)) {
    accountLabel = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.account');
  }
  var passwordLabel = 'Password:';
  if ((0, _get2["default"])(Appdefs, 'app.login.labels.password', null)) {
    passwordLabel = (0, _get2["default"])(Appdefs, 'app.login.labels.password');
  } else if ((0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.password', null)) {
    passwordLabel = (0, _get2["default"])(Fortress, 'settings.config.loginFormLabels.password');
  }
  var forgotPasswordText = props.forgotPasswordText || (0, _get2["default"])(Appdefs, 'app.login.labels.forgotPasswordText', 'Forgot your password?');
  var forgotUsernameText = props.forgotUsernameText || (0, _get2["default"])(Appdefs, 'app.login.labels.forgotUsernameText', 'Forgot your username?');
  var onLoginSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      var response, finalRedirectUrl, surveyUrl, setMfaFunc;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _cccisdAxios["default"].post(Boilerplate.route('api.nexus.login'), values);
          case 2:
            response = _context.sent;
            if (!(response.data.status === 'success')) {
              _context.next = 17;
              break;
            }
            finalRedirectUrl = redirectUrl + urlParams.queryParams + urlParams.anchor;
            if (response.data.data.hasIncompleteSiteRegistration) {
              surveyUrl = Boilerplate.url('/account/registrationSurvey') + "?redirectUrl=".concat(defaultRedirectUrl);
              setRedirectUrl(surveyUrl);
              finalRedirectUrl = surveyUrl;
            }
            if (!('isMfa' in response.data.data && response.data.data.isMfa)) {
              _context.next = 10;
              break;
            }
            setMfaFunc = props.setMfaProps || setMfaProps;
            setMfaFunc(_objectSpread(_objectSpread({}, response.data.data), {}, {
              onSuccess: onSuccess,
              loginResponse: response,
              redirectUrl: finalRedirectUrl
            }));
            return _context.abrupt("return");
          case 10:
            if (!onSuccess) {
              _context.next = 13;
              break;
            }
            _context.next = 13;
            return onSuccess(response);
          case 13:
            setRedirectUrl(finalRedirectUrl);
            setPerformRedirect(true);
            _context.next = 18;
            break;
          case 17:
            throw response.data.errors;
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onLoginSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var cleverClientId = (0, _get2["default"])(Fortress, 'settings.config.sso.clever.clientId', null);
  var cleverLoginWith = (0, _get2["default"])(Fortress, 'settings.config.sso.clever.loginWithButton', false);
  var cleverRedirectUri = Boilerplate.url('/api/clever');
  var classlinkClientId = (0, _get2["default"])(Fortress, 'settings.config.sso.classlink.clientId', null);
  var classlinkLoginWith = (0, _get2["default"])(Fortress, 'settings.config.sso.classlink.loginWithButton', false);
  var classlinkRedirectUri = Boilerplate.url('/api/sso/classlink');
  var forgotUsername = (0, _get2["default"])(Fortress, 'settings.config.username.forgot_username', false);
  var cleverLoginUrl = 'https://clever.com/oauth/authorize?response_type=code&client_id=' + cleverClientId + '&redirect_uri=' + cleverRedirectUri;
  var classlinkLoginUrl = 'https://launchpad.classlink.com/oauth2/v2/auth' + '?scope=profile' + '&response_type=code' + '&client_id=' + classlinkClientId + '&redirect_uri=' + classlinkRedirectUri;
  var cleverLogin = function cleverLogin() {
    window.location = cleverLoginUrl;
  };
  var classlinkLogin = function classlinkLogin() {
    window.location = classlinkLoginUrl;
  };
  if (mfaProps !== undefined) {
    return /*#__PURE__*/_react["default"].createElement(_Mfa["default"], mfaProps);
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: onLoginSubmit,
    validate: validate,
    render: function render(formikProps) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, title && /*#__PURE__*/_react["default"].createElement("h4", {
        className: _style["default"].title
      }, title), topInstructions && /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].topInstructions
      }, topInstructions), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "username",
        component: _cccisdFormik.CccisdInput,
        label: accountLabel,
        autoComplete: "username"
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "password",
        component: _cccisdFormik.CccisdPasswordInput,
        label: passwordLabel,
        showPasswordToggle: showPasswordToggle,
        showPasswordByDefault: showPasswordByDefault,
        autoComplete: "current-password"
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].link,
        style: {
          display: 'flex',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: Boilerplate.url('/account/forgot')
      }, forgotPasswordText), forgotUsername && /*#__PURE__*/_react["default"].createElement("a", {
        href: Boilerplate.url('/account/forgotUsername')
      }, forgotUsernameText))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative',
          width: '100%',
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        onClick: formikProps.handleSubmit,
        title: buttonText,
        className: "btn btn-primary",
        isLoading: formikProps.isSubmitting,
        style: {
          margin: '0 auto',
          width: '75%'
        }
      })), (cleverLoginWith && cleverClientId !== null || classlinkLoginWith && classlinkClientId !== null) && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].thinLine
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative',
          display: 'inline-block',
          width: '20%',
          padding: '1em 0'
        }
      }, "OR"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].thinLine
      })), cleverLoginWith && cleverClientId !== null && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative',
          width: '100%',
          textAlign: 'center',
          marginBottom: '1.0em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        onClick: cleverLogin,
        title: /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: _Clever["default"],
          alt: "Clever Logo",
          style: {
            width: '2.0em',
            position: 'relative',
            left: '2px'
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            position: 'relative',
            left: '15%'
          }
        }, "Login with Clever")),
        className: 'btn ' + _style["default"].btnClever + ' ' + _style["default"].btnLogo
      })), classlinkLoginWith && classlinkClientId !== null && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative',
          width: '100%',
          textAlign: 'center',
          marginBottom: '1.0em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        onClick: classlinkLogin,
        title: /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: _Classlink["default"],
          alt: "Classlink Logo",
          style: {
            width: '2.0em',
            height: '32px'
          }
        }), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            position: 'relative',
            left: '15%'
          }
        }, "Login with Classlink")),
        className: 'btn ' + _style["default"].btnClasslink + ' ' + _style["default"].btnLogo
      })), bottomInstructions && /*#__PURE__*/_react["default"].createElement("p", {
        className: _style["default"].bottomInstructions
      }, bottomInstructions));
    }
  });
};
LoginForm.propTypes = {
  bottomInstructions: _propTypes["default"].string,
  buttonText: _propTypes["default"].string,
  defaultRedirectUrl: _propTypes["default"].string,
  forgotPasswordText: _propTypes["default"].string,
  forgotUsernameText: _propTypes["default"].string,
  onSuccess: _propTypes["default"].func,
  showPasswordByDefault: _propTypes["default"].bool,
  showPasswordToggle: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  topInstructions: _propTypes["default"].string
};
LoginForm.defaultProps = {
  defaultRedirectUrl: Boilerplate.url(Fortress.settings.config.after_login_url)
};
var _default = exports["default"] = LoginForm;